import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'airway-bills' });

export const { find, create, get, patch, reducer, remove, update } = actions;

export default reducer;
